import parse from 'html-react-parser'
import Head from 'next/head'

import { FRONT_BASE_URL } from '@/constants'

import { WPPageData } from '@/types'

export type MetaProps = {
  pageProps: WPPageData
}

const Meta = ({ pageProps }: MetaProps) => {
  const { yoast_head } = pageProps

  return <Head>{parse(yoast_head?.replace(/"\//g, `"${FRONT_BASE_URL}/`) || '')}</Head>
}

export default Meta
